import { NavLink, useNavigate } from 'react-router-dom'
import artaLogo from 'assets/img/logo.png'
import UserService from 'Main/service/UserService'
import { companyName } from 'version'
import { navigation } from 'navigation'

function SidebarPanel ({ user, collapsed, onClose }) {
  const navigate = useNavigate()
  const userService = new UserService()
  const isAdmin = ['ADMIN', 'SUPERADMIN'].includes(user?.type)

  const handleLogout = async () => {
    try {
      await userService.logout()
    } finally {
      navigate('/auth/login', { replace: true })
    }
  }

  return (
    <aside className="artapay-sidebar" aria-label="Primary navigation">
      <div className="artapay-brand">
        <NavLink to="/dashboard" className="artapay-brand-link" onClick={onClose}>
          <span className="artapay-brand-mark"><img src={artaLogo} alt="" /></span>
          <span className="artapay-brand-copy">
            <strong>ArtaPay</strong>
            <small>Payment gateway</small>
          </span>
        </NavLink>
        <button type="button" className="artapay-sidebar-close" aria-label="Close navigation" onClick={onClose}>
          <i className="fa-solid fa-xmark" />
        </button>
      </div>

      <nav className="artapay-nav">
        {navigation.filter((group) => !group.admin || isAdmin).map((group) => (
          <div className="artapay-nav-group" key={group.label}>
            <span className="artapay-nav-label">{group.label}</span>
            {group.items.map((item) => (
              <NavLink
                key={item.to}
                to={item.to}
                end={item.end}
                title={collapsed ? item.label : undefined}
                className={({ isActive }) => `artapay-nav-item${isActive ? ' active' : ''}`}
                onClick={onClose}
              >
                <i className={`fa-solid ${item.icon}`} />
                <span>{item.label}</span>
              </NavLink>
            ))}
          </div>
        ))}
      </nav>

      <div className="artapay-sidebar-footer">
        <NavLink to="/dashboard/profile" className="artapay-account-link" onClick={onClose}>
          <span className="artapay-account-avatar">{(user?.name || user?.username || 'A').charAt(0).toUpperCase()}</span>
          <span className="artapay-account-copy">
            <strong>{user?.name || user?.username || companyName}</strong>
            <small>Manage profile</small>
          </span>
          <i className="fa-solid fa-chevron-right" />
        </NavLink>
        <button type="button" className="artapay-logout" onClick={handleLogout} title={collapsed ? 'Sign out' : undefined}>
          <i className="fa-solid fa-arrow-right-from-bracket" />
          <span>Sign out</span>
        </button>
      </div>
    </aside>
  )
}

export default SidebarPanel
